import React, { Component } from "react";
//// componentes reutilizables
import TecladoPin from "../../../generico/TecladoPin";
import NumberFormat from "react-number-format";
import md5 from "md5";
import Popup from "react-popup";
import { trackPromise } from "react-promise-tracker";
import AuthService from "../../../../services/login/auth.service";
import TransferXpressService from "../../../../services/transferencias/TransferXpressService";
import MensajeUsuario from "../../../generico/MensajeUsuario";
import { MENSAJE } from "../../../generico/utils/Constantes";
import {FontAwesomeIcon}  from "@fortawesome/react-fontawesome";
import {faArrowRight, faArrowLeft} from "@fortawesome/free-solid-svg-icons";

//TransferenciaXpressPaso3
export default class TransferenciaXpressPaso3 extends Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState();
    this.tecladoPinRef = React.createRef();
  }
  getInitialState = () => ({
    pin: "",
    nroOperacion: 0,
    disableSgte: true,
  });

  resetState = () => {
    this.setState(this.getInitialState());
    this.tecladoPinRef.current.limpiarPin();
  };


  confirmarTransferencia = (titulo, mensaje, callback) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "No",
            className: "",
            action: function () {
              Popup.close();
            },
          },
          {
            text: "Sí",
            className: "success",
            action: function () {
              callback();
              Popup.close();
            },
          },
        ],
      },
    });

  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    });


  pinValue = (value) => {
    this.setState({
      pin: value,
    });
    this.enableNext(value);
  };
  enableNext(pin) {
    if (pin !== "" && pin.length === 6) {
      this.state.disableSgte = false;
    } else {
      this.state.disableSgte = true;
    }
  }

  obtenerTipoCuentaDestino() {
    if (this.props.cuentaDestino.destinatario === "1602") {
      return "BANCOD";
    }
    if (this.props.cuentaDestino.destinatario === "1600") {
      return "TPD";
    } else {
      return "CCAHOD";
    }
  }

  confirmar = (e, transferenciaDatosRepetidos = false) => {
    //// bloquea boton
    this.btn.setAttribute("disabled", "disabled");
    var importe = this.props.importe.split(".").join("");
    importe = String(importe).replace(/\,/g, ".");

    var data = JSON.stringify({
      numCuentaOrigen: this.props.cuentaOrigen.ahorro, //
      docDestinatario: this.props.cuentaDestino.docDestino, // ?,
      titularDestinatario: this.props.cuentaDestino.titular, // ?
      numCuentaDestino:
        this.props.cuentaDestino.destinatario === "1600"
          ? null
          : this.props.cuentaDestino.nroCuenta.toString(), // ?
      codDestinatario: this.props.cuentaDestino.destinatario,
      tipoCuentaDestino: this.obtenerTipoCuentaDestino(), //// TODO: se pasa en duro por ahora
      importe: importe.toString(), //
      canalOrigen: "CU24HS_WEB", //
      telefonoDestino: this.controlCelular() === true ? this.props.celular : "", //
      motivoOperacion: this.props.motivo, //
      codigoEntidad: this.props.cuentaDestino.codEntidad, // ?
      pinTransaccional: md5(this.state.pin), //
      transferenciaDatosRepetidos
    });

    trackPromise(
      TransferXpressService.confirmarTransferencia(data).then((response) => {
        //// Habilita boton
        this.btn.removeAttribute("disabled");
        var data = JSON.stringify(response.data);
        var jData = JSON.parse(data);

        if (jData.codigoRetorno === "0") {
          var nroOperacion = jData.datos.idTxOriginante;
          this.props.returnDataPaso3(nroOperacion);
          this.nextStep.click();
        } else if (jData.codigoRetorno === "-1") {
          Popup.queue(this.confirmarTransferencia("Atención", MENSAJE.CONFIRMAR_TRANSFERENCIA, (e) => this.confirmar(e, true)));
        } else {
          Popup.queue(this.notifiPopup("Info", jData.mensajeRetorno));
        }
      })
    ).catch(function (error) {
      console.log(error);
      Popup.queue(
        Popup.register({
          title: "Error Inesperado.",
          content:
            "Intenta volver a recargar esta página o no dudes en contactar con nosotros si el problema persiste.",
          buttons: {
            right: [
              {
                text: "Aceptar",
                className: "success",
                action: function () {
                  Popup.close();
                },
              },
            ],
          },
        })
      );
    });
  };

  controlCelular() {
    if (
      this.props.celular !== null &&
      this.props.celular !== undefined &&
      this.props.celular !== ""
    ) {
      let celularNumero = this.props.celular.replace("_", "");
      if (celularNumero.length === 10) {
        return true;
      }
    }
    return false;
  }
  render() {
    return (
      <div>
        <form id="idFormPaso3" onSubmit={(e) => e.preventDefault()}>
          <div className="row">
            <div className="steps clearfix">
              <ul role="tablist">
                <li role="tab" className="disabled">
                  <span>
                    <div className="title">
                      <span className="title_text current">
                        Selección de Cuentas
                      </span>
                    </div>
                  </span>
                </li>
                <li role="tab" className="disabled">
                  <span>
                    <div className="title">
                      <span className="title_text">Datos de Transferencia</span>
                    </div>
                  </span>
                </li>
                <li role="tab" className="current">
                  <span>
                    <div className="title">
                      <span className="title_text">Datos de Verificación</span>
                    </div>
                  </span>
                </li>
                <li role="tab" className="disabled last">
                  <span>
                    <div className="title">
                      <span className="title_text">Confirmación</span>
                    </div>
                  </span>
                </li>
              </ul>
            </div>
          </div>

          <div className="row">
            <div className="col-md-8">
              <div className="row">
                <div className="col-8" style={{ marginBottom: 5 }}>
                  <h6 className="item-vef" style={{ margin: 0 }}>
                    Cuenta: {this.props.cuentaOrigen.ahorro} -{" "}
                    {AuthService.getSocio().nombreCompleto.trim()}
                  </h6>
                  <p className="item-vef" style={{ marginBottom: 0 }}>
                    Tipo: {this.props.cuentaOrigen.descripcion}
                  </p>
                  <p className="item-vef">Moneda: {this.props.cuentaOrigen.moneda}</p>
                </div>
              </div>
              <div className="row invoice-info">
                <div className="col-12">
                  <div className="table-responsive">
                    {this.props.cuen}
                    <table className="table">
                      <tbody>
                        <tr>
                          <th>Cuenta Crédito:</th>
                          <td>{this.props.cuentaDestino.nroCuenta}</td>
                        </tr>
                        <tr>
                          <th>Importe del Crédito:</th>
                          <td>
                            <NumberFormat
                              value={this.props.importe}
                              displayType={"text"}
                              decimalSeparator={","}
                              thousandSeparator={"."}
                            />{" "}
                            {this.props.cuentaOrigen.moneda}.
                          </td>
                        </tr>
                        <tr>
                          <th>Titular de la cuenta destino:</th>
                          <td>{this.props.cuentaDestino.titular}</td>
                        </tr>
                        <tr>
                          <th>Tipo documento de la cuenta destino:</th>
                          <td>{this.props.cuentaDestino.tipoDocDestino}</td>
                        </tr>
                        <tr>
                          <th>Documento de la cuenta destino:</th>
                          <td>{this.props.cuentaDestino.docDestino}</td>
                        </tr>
                        <tr>
                          <th>Entidad:</th>
                          <td>{this.props.cuentaDestino.entidad}</td>
                        </tr>
                        <tr>
                          <th>Motivo:</th>
                          <td>{this.props.motivo}</td>
                        </tr>
                        {this.controlCelular() === true && (
                          <tr>
                            <th>Celular del destinatario:</th>
                            <td>{this.props.celular}</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              
            </div>
            <div className="col-md-4">
                <div className="invoice p-3 mb-3 teclados">
                  <TecladoPin
                    pinValue={this.pinValue.bind(this)}
                    label="Ingrese el Pin de Transacción"
                    ref={this.tecladoPinRef}
                  />
                </div>

            </div>
          </div>
          <div className="col-lg-8 col-md-12">
                <div className="col-12">
                  <MensajeUsuario
                    tipo="INFO"
                    titulo="Importante!"
                    mensaje="- El límite diario es de 6.000.000 Gs. (establecido por Bancard)."
                    mensaje2="-Cantidad de operaciones sin costo: 7
                    - Monto a descontar al exceder las 7 operaciones:
                    5.500 Gs. 
                    
                    -Todas las operaciones realizadas son de exclusiva
                    responsabilidad del socio, en caso de errores en la imputación de
                    las transferencias, las reversiones dependen de la aprobación de
                    la entidad receptora."
                  />
                </div>
              </div>
          <hr/>
          <div className="row">
          <div className="col-lg-6 col-md-6"></div>
          <div className="col-lg-3 col-md-3">
          <button
              className="btn btn-cu-quintary btn-consulta"
              onClick={this.props.previousStep}>
             <FontAwesomeIcon icon={faArrowLeft} /> Volver
            </button>
          </div>
          <div className="col-lg-3 col-md-3">
          <button
              ref={(btn) => {
                this.btn = btn;
              }}
              className="btn btn-cu-primary"
              disabled={this.state.disableSgte}
              onClick={this.confirmar}
            >
              Confirmar Transferencia <FontAwesomeIcon icon={faArrowRight} />
            </button>
            <button
              hidden
              ref={(a) => (this.nextStep = a)}
              className="btn btn-cu-primary"
              onClick={this.props.nextStep}
            ></button></div>  
          </div>                
        </form>
      </div>
    );
  }
}
